import React from 'react'
import { Box, Link, Text, VStack } from '@chakra-ui/react'
import { motion } from 'framer-motion'



type CourseProps = {
    title: string;
    subTitle: string;
    image: any;
    href: string;
}


const Course = ({title, subTitle, image, href}: CourseProps) => {
    
  return (
        <Link
            href={href}
            display="block"
            textDecoration="none"
            _hover={{ textDecoration: 'none' }}>
        <motion.div
            whileHover={{ scale: 1.025, y: -6 }}
            transition={{ duration: 0.25 }}
        >
            <Box
                height={{ base: '410px', md: '520px' }}
                backgroundImage={image}
                backgroundColor={'black'}
                backgroundSize={'cover'}
                backgroundPosition={'center'}
                backgroundRepeat={'no-repeat'}
                borderRadius={{ base: '22px', md: '28px' }}
                overflow="hidden"
                position={'relative'}
                boxShadow="0 12px 30px rgba(25, 25, 35, 0.12)"
                >
                    <Box
                        position={'absolute'}
                        bottom={0}
                        left={0}
                        w={'100%'}
                        h={'58%'}
                        bgGradient={'linear(to-t, rgba(0, 0, 0, 0.82), rgba(0, 0, 0, 0))'}
                        zIndex={1}
                    />
                    <VStack
                        position="absolute"
                        left={{ base: 5, md: 7 }}
                        right={{ base: 5, md: 7 }}
                        bottom={{ base: 5, md: 7 }}
                        align="flex-start"
                        spacing={2}
                        zIndex={2}
                    >
                        <Text
                            color={'white'}
                            fontSize={{ base: '2xl', md: '3xl' }}
                            fontWeight={'bold'}
                            lineHeight="1.08"
                            textAlign={'left'}
                            >
                            {title}
                        </Text>
                        <Text
                            color={'white'}
                            fontSize={{ base: 'md', md: 'lg' }}
                            fontWeight={'light'}
                            opacity={0.9}
                            textAlign={'left'}
                            >
                            {subTitle}
                        </Text>
                    </VStack>
            </Box>
        
        </motion.div>
        </Link>
  )
}

export default Course
